<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/html_behaviors/af-sort-column"></require>
  <require from="framework/html_behaviors/af-sort-context"></require>
  <require from="controls/as-table-skeleton"></require>
  <require from="components/filters/airlines-filter"></require>
  <require from="controls/as-page-header"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-widget.html"></require>

  <div class="airlines-list-screen">
    <as-page-jumbo if.bind="!mobileAppService.isMobileApp" icon="fas fa-plane-departure fa-fw" heading="Airlines Rating" intro="Check airlines rating and find the best transportation partner for your trip.">
      <div slot="default">
        <as-form-widget>
          <div slot="default">
            <airlines-filter model.bind="filter" mutated.call="filterMutated()"></airlines-filter>
          </div>
        </as-form-widget>
        <div class="sc-buttons-container">
          <button type="button" class="btn btn-light" af-mutex-click.call="downloadSpreadsheet()">
            <i class="fas fa-download"></i> Download Spreadsheet
          </button>
        </div>
      </div>
    </as-page-jumbo>
    <div class="container-fluid">
      <as-page-header if.bind="mobileAppService.isMobileApp" heading="Airlines Rating" is-mobile-app-cancel="true">
      </as-page-header>
      <div if.bind="mobileAppService.isMobileApp" class="sc-filter-container">
        <airlines-filter model.bind="filter" mutated.call="filterMutated()"></airlines-filter>
      </div>
      <table class="table table-borderless sc-table-fixed sc-table-sticky sc-list-highlight" af-sort-context.bind="sortInstruction">
        <thead>
          <tr>
            <th width="75px" class="d-none d-lg-table-cell" af-sort-column="Code">Code</th>
            <th width="55px" class="d-lg-none" af-sort-column="Code">Code</th>
            <th width="220px" class="d-none d-lg-table-cell" af-sort-column="Name">Name</th>
            <th width="180px" class="d-none d-md-table-cell d-lg-none" af-sort-column="Name">Name</th>
            <th class="d-md-none" af-sort-column="Name">Name</th>
            <th class="d-none d-md-table-cell" af-sort-column="Comment">Comment</th>
            <th width="125px" class="d-none d-lg-table-cell" af-sort-column="AirlineRating">Rating</th>
            <th width="81px" class="d-lg-none" af-sort-column="AirlineRating">Rating</th>
            <th width="205px" class="d-none d-lg-table-cell" af-sort-column="AirlineStatus">Status</th>
            <th width="65px" class="d-lg-none" af-sort-column="AirlineStatus">Status</th>
          </tr>
        </thead>
        <tbody if.bind="loaded">
          <template repeat.for="airline of airlines">
            <tr class="${$index % 2 ? 'sc-row-even' : ''} sc-row-pair-1 sc-content-appear">
              <td title="${airline.code}" innerhtml="${airline.highlightedCode | sanitizeHTML}"></td>
              <td title="${airline.name}" innerhtml="${airline.highlightedName | sanitizeHTML}"></td>
              <td class="d-none d-md-table-cell" title="${airline.comment}" innerhtml="${airline.highlightedComment | sanitizeHTML}"></td>
              <td title="${airline.airlineRating.name}">${airline.airlineRating.name}</td>
              <td class="d-none d-lg-table-cell" title="${airline.airlineStatus.name}">
                <span><i class="fas fa-fw fa-xs mr-2 ai-airline-status ${'--status-' + airline.airlineStatus.value}"></i></span>
                ${airline.airlineStatus.name}
              </td>
              <td class="d-lg-none text-right" title="${airline.airlineStatus.name}">
                <span><i class="fas fa-fw fa-xs mr-2 ai-airline-status ${'--status-' + airline.airlineStatus.value}"></i></span>
              </td>
            </tr>
            <tr class="d-md-none ${$index % 2 ? 'sc-row-even' : ''} sc-row-pair-2 sc-content-appear" if.bind="airline.comment">
              <td></td>
              <td colspan="2" title="${airline.comment}" innerhtml="${airline.highlightedComment | sanitizeHTML}"></td>
            </tr>
          </template>
        </tbody>
        <tbody as-element="as-table-skeleton" else></tbody>
      </table>
      <div class="sc-table-norows" if.bind="airlines.length === 0">No items found</div>
    </div>
  </div>
</template>
